import { REIButton, REIDropDown, REIInputText } from "../../../components/ui";
import { httpPost, useHttpGet } from "../../../services/httpService";
import { ALERT_OPTIONS, MEMBER_KEY } from "../../../utils/constants";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiEndPoints } from "../../../utils/endpoints";
import { Toast } from "primereact/toast";
import { ISaveSearch } from "../../../interface/ISaveSearch";
import { updateSearchState } from "../../../store/slice/searchStateSlice";
import { RootState } from "../../../store";

export interface ISaveThisSearchProps {
  closeDialog?: () => void;
  savesearch?: ISaveSearch | null;
}

interface ISavedSearchResponse {
  SavedSearchID?: number;
  ErrorsCollection: any;
}

const SaveThisSearch: React.FC<ISaveThisSearchProps> = ({ closeDialog, savesearch }) => {
  const [alert, setAlert] = useState(1);
  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(false);
  const toastRef = useRef<Toast>(null);
  const dispatch = useDispatch();
  const isFilterApplied = useSelector((state: RootState) => state.searchState.isFilterApplied);

  const memberId = localStorage.getItem(MEMBER_KEY);
  const endpoint = `${ApiEndPoints.search}/${memberId}`;
  const { data: searchlist, error } = useHttpGet(endpoint, undefined, true);

  const onAlertDropDownChange = (e) => {
    setAlert(e.value);
  };

  const saveAlert = async (id) => {
    const body = {
      MemberId: localStorage.getItem("member_id"),
      FilterEmailAlertSchedule: [
        {
          FilterEmailAlertScheduleId: alert,
        },
      ],
      SavedSearch: [
        {
          Id: id,
        },
      ],
    };
    await httpPost(`${ApiEndPoints.search}/EmailAlert`, body);
  };

  const saveThisSearch = async () => {
    if (loading) return;
    if (!isFilterApplied || savesearch==null) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error Message",
        detail: "Please add one or more filters to save this search.",
        life: 2000,
      });
      setTimeout(() => {
        setLoading(false);
        closeDialog?.();
      }, 2000);
      return;
    } else {
    const searchToSave = savesearch
      ? {
          ...savesearch,
          Country: {
            ...(savesearch.Country ?? {}),
            Title: searchName,
          },
        }
      : undefined;

    const index =
      searchlist &&
      searchlist.SavedSearch?.findIndex((x) => x.Title.toLowerCase() == searchName.toString().toLowerCase());
    if (index >= 0) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error Message",
        detail: "Entered name already exists. Please add another name.",
        life: 3000,
      });
      return;
    }

    setLoading(true);

    try {
      const response = await httpPost(ApiEndPoints.search, searchToSave);
      const savedSearchId = (response?.data as ISavedSearchResponse | null)?.SavedSearchID;
      if (response?.error) {
        toastRef.current?.show({
          severity: "error",
          summary: "Error Message",
          detail: response.error,
          life: 3000,
        });
      } else if (savedSearchId != null) {
        await saveAlert(savedSearchId);
        dispatch(updateSearchState({ searchData: searchToSave }));
        toastRef.current?.show({
          severity: "success",
          summary: "Success Message",
          detail: "My saved search saved successfully.",
          life: 2000,
        });
      } else {
        toastRef.current?.show({
          severity: "error",
          summary: "Error Message",
          detail: "Saved search response was incomplete.",
          life: 3000,
        });
      }
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error Message",
        detail: "Unable to save search at the moment.",
        life: 3000,
      });
    } finally {
      setTimeout(() => {
        closeDialog?.();
        setLoading(false);
      }, 2000);
    }
    }
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div className="flex flex-row mb-2">
        <label className="block font-medium">Please give this search as name.</label>{" "}
      </div>
      <div className="flex flex-row">
        <REIInputText
          id="svsch-txt-name"
          type="text"
          name="searchName"
          className="w-full"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
      </div>
      <div className="flex flex-row mb-2 mt-3">
        <label className="block font-medium">
          How often would you like to receive email alerts of properties matching this search.
        </label>
      </div>
      <div className="flex flex-row">
        <div className="w-1/3">
          <REIDropDown
            id="svsch-drop-alert"
            value={alert}
            onSelectionChange={onAlertDropDownChange}
            data={ALERT_OPTIONS}
            label="name"
            optionValue="code"
            placeholder="Inactive"
          />
        </div>
        <div className="w-8/12 text-end">
          <REIButton
            id="svsch-btn-submit"
            label="Save search"
            disabled={loading || !searchName}
            loading={loading}
            icon="pi pi-save"
            onClick={() => {
              saveThisSearch();
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SaveThisSearch;
